import { Clock, Eye, User } from "lucide-react";
import React from "react";

/**
 * @typedef {Object} BlogMetaProps
 * @property {string} date
 * @property {string} readTime
 * @property {boolean} isByOyeCreator
 * @property {string} author
 * @property {string} className
 * @property {number} iconSize
 * @property {boolean} showIcons
 */
/**
 * @param {BlogMetaProps} props
 * @returns {React.ReactNode}
 */
export const BlogMeta = ({
  date,
  readTime,
  isByOyeCreator,
  author,
  className = "",
  iconSize = 16,
  showIcons = true,
}) => {
  return (
    <div
      className={`flex flex-wrap items-center text-sm text-gray-600 gap-5 ${className}`}
    >
      <div className="flex items-center gap-1.5">
        {showIcons && <Clock size={iconSize} className="text-primary/80" />}
        <span className="font-medium text-gray-700">{date}</span>
      </div>
      <div className="flex items-center gap-1.5">
        {showIcons && <Eye size={iconSize} className="text-primary/80" />}
        <span className="font-medium text-gray-700">{readTime}</span>
      </div>
      {isByOyeCreator ? (
        <div className="flex items-center gap-1.5">
          {showIcons && <User size={iconSize} className="text-primary/80" />}
          <span className="font-medium text-gray-700">Oye Creator</span>
        </div>
      ) : (
        <div className="flex items-center gap-1.5">
          {showIcons && <User size={iconSize} className="text-primary/80" />}
          <span className="font-medium text-gray-700">{author}</span>
        </div>
      )}
    </div>
  );
};
